(() => {
  const query = window.matchMedia('(max-width: 749px)');
  const setFooter = () => {
    document.querySelectorAll('.deko-footer__col').forEach(item => {
      item.open = !query.matches;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setFooter);
  else setFooter();
  query.addEventListener('change', setFooter);
  const setFeatured = () => {
    const track = document.getElementById('deko-featured-products');
    if (!track) return;
    document.querySelectorAll('[data-deko-slide]').forEach(button => {
      button.addEventListener('click', () => {
        const first = track.querySelector('.deko-product-card');
        if (!first) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const direction = button.dataset.dekoSlide === 'next' ? 1 : -1;
        track.scrollBy({left:direction * (first.getBoundingClientRect().width + gap),behavior:'smooth'});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setFeatured);
  else setFeatured();
})();
